<template>

    <div class="bmp">

        <div class="body">

            <h1 class="title-baseSemibold">{{$t('download_app_dear_user')}}</h1>

            <p class="text-baseRegular mt__12">{{$tc('download_app_impossible_to_connect_1', 0, {provider})}}</p>
            <p class="text-baseRegular">{{$tc('download_app_impossible_to_connect_2', 0, {provider})}}</p>

            <img src="/img/icons/close-white.svg" class="img__16 cancel" @click="goLanding">
            <img src="/img/block/Illustration-Redirect-iPhone.svg" class="phone" v-show="showPhone">
            <img src="/img/stats/foxy-smile.svg" class="foxy">
        </div>
        <div class="bottom">

            <button class="cta-medium-secondary" @click="redirect">{{$t('partial_fetch_download_app')}}</button>

        </div>
    </div>

</template>

<script>

import Vuex from 'vuex'

export default {

    name: 'block-mobile-popup',

    props: {
        provider: {
            type: String,
            default: ''
        }
    },

    computed: {
        ...Vuex.mapGetters([
            'innerHeight'
        ]),

        showPhone() {
            return this.innerHeight > 620
        }
    },

    methods: {

        goLanding() {
            this.$router.push({path: '/'})
        },

        redirect() {
            window.location.href = 'https://app.adjust.com/uez2im'
        }
    }

}
</script>

<style lang="scss" scoped>

.bmp {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background: linear-gradient(126deg, #2B6C5D 0%, #2C556A 100%);
    display: flex;
    flex-direction: column;

    .body {
        color: $white;
        flex: 1;
        padding: 32px 16px;
        display: flex;
        flex-direction: column;
        position: relative;
        align-items: center;
        text-align: start;

        h1 {
            width: 100%;
        }

        .cancel {
            position: absolute;
            right: 16px;
            top: 16px;
            cursor: pointer;
        }

        .phone {
            position: absolute;
            bottom: -140px;
            width: 225px;
        }

        .foxy {
            position: absolute;
            bottom: -40px;
            right: 6px;
            width: 80px;
            z-index: 2;
        }
    }

    .bottom {
        padding: 12px 24px;
        background-color: $white;
        z-index: 1;

    }
}

</style>
